// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","pageTitle":"u1t_e8fPev2v8GhP49vp2","noContentMsg":"_3C67enBn_tUE63nXkrW0qO"};